import { AllCheckoutItemViews } from 'checkout/selectors/view/getAllItemViewsByType'
import { flightsImageId } from 'constants/flight'
import {
  BasicTrip,
  TripItemAndOfferAndDatesIdSet,
} from 'tripPlanner/types/common'
import { getDefaultTripImageId } from 'tripPlanner/utils'

export const extractOfferIdsFromOrder = (order: App.Order) => {
  if (!order) {
    return []
  }

  return [
    ...order.items.map((i) => i.offerId),
    ...order.bedbankItems.map((i) => i.offer.id),
    ...order.tourItems.map((i) => i.tourId),
  ]
}

export function getTripImageFromCheckoutItems(
  checkoutItemViews: AllCheckoutItemViews,
  trips?: Array<BasicTrip>,
) {
  const experienceImage =
    checkoutItemViews.data.experienceItemsView.data[0]?.externalImage?.id
  if (experienceImage) {
    return experienceImage
  }

  const accommodationImage =
    checkoutItemViews.data.accommodationItemsView.data[0]?.image?.id
  if (accommodationImage) {
    return accommodationImage
  }

  if (checkoutItemViews.data.flightItemsView.data[0]) {
    return flightsImageId
  }

  return getDefaultTripImageId(trips)
}

export function getTripItemIdsInCheckout(
  keys: Array<string>,
  idSets: Array<TripItemAndOfferAndDatesIdSet>,
) {
  const itemKeys = new Set(keys)

  const itemIds = idSets
    .filter((s) => itemKeys.has(s.offerIdAndMeta))
    .map((i) => i.itemId)

  return itemIds
}
